"use strict";

goog.provide("Ntry.Interpreter");

goog.require("Ntry.STATIC");

Ntry.Interpreter = function() {
    this._status = Ntry.STATIC.ENGINE_STOP;

    Ntry.addEventListener("engineButtonClicked", this, this.changeStatus);
    Ntry.addEventListener("complete", this, this.clearScript);
    Ntry.addEventListener("replay", this, this.replayStatus);
};

(function(p){
    p.update = function() {
        /* execute block func */
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.CODE);
        for (var id in entities) {
            var entity = entities[id];
            this.computeFunction(entity);
        }
    };

    p.computeFunction = function(entity) {
        var codeComponent = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.CODE
        );
        var code = codeComponent.code;

        code.tick();
    };

    p.clearScript = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.CODE);
        for (var id in entities) {
            var codeComponent = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.CODE
            );
            var code = codeComponent.code;

            code.clearExecutors();
        }
    }

    p.getStatus = function () {
        return this._status;
    };

    p.setStatus = function (status) {
        this._status = status;
        var STATIC = Ntry.STATIC;
        var button = this._engineButton;

        switch (status) {
            case STATIC.ENGINE_STOP:
                this.clearScript();
                Ntry.dispatchEvent("stop");
                break;
            case STATIC.ENGINE_RUN:
                Ntry.dispatchEvent("run");
                this.raiseEvent();
                break;
            case STATIC.ENGINE_END:
                //Ntry.dispatchEvent("stop");
                break;
        };
    };

    p.changeStatus = function() {
        var status = this.getStatus();
        var STATIC = Ntry.STATIC;
        switch (status) {
            case STATIC.ENGINE_STOP:
                this.setStatus(STATIC.ENGINE_RUN);
                break;
            case STATIC.ENGINE_RUN:
                this.setStatus(STATIC.ENGINE_STOP);
                break;
            case STATIC.ENGINE_END:
                this.setStatus(STATIC.ENGINE_STOP);
                break;
        };
    };

    p.replayStatus = function() {
        this.setStatus(Ntry.STATIC.ENGINE_END);
    };

    p.raiseEvent = function() {
        var ws = Entry.mainWorkspace;
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.CODE);
        for (var key in entities) {
            var entity = entities[key];
            var codeComponent = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.CODE
            );
            if (ws.getMode() == Entry.Workspace.MODE_VIMBOARD) {
                var code = ws.vimBoard.textToCode(Entry.Vim.TEXT_TYPE_JS);
                codeComponent.code.load(code);
            }
            codeComponent.code.raiseEvent("start", entity);
        }
        /* add running script */
    }

})(Ntry.Interpreter.prototype);
